module.exports = __webpack_public_path__ + "img/bg_content.747e2571.png";